module.exports = __webpack_public_path__ + "media/images/front/icons/play_arrow-e4c88aca32250cc3bd8f946559a2a957.svg";